import { Component, OnInit } from "@angular/core";
import { CommunicareScheduleWebhookService, ListLogWebhookCommunicareFilterInputDTO, LogCommunicareWebhookEvent, LogCommunicareWebhookStatus, LogWebhookCommunicareDTO, LogWebhookCommunicareOutputDTO } from "../../services/communicare-schedule-webhook.service";
import { MatTableDataSource } from "@angular/material/table";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { catchError, finalize, take, tap } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UUID } from "crypto";
import { MatDialog } from "@angular/material/dialog";
import { CommunicareScheduleWebhookModalComponent } from "./modal/communicare-schedule-webhook-modal.component";
import { PageEvent } from "@angular/material/paginator";

@Component({
    selector: 'app-communicare-schedule-webhook',
    templateUrl: './communicare-schedule-webhook.component.html',
    styleUrls: ['./communicare-schedule-webhook.component.scss']
})
export class CommunicareScheduleWebhook implements OnInit {
    constructor(
        private readonly snack: MatSnackBar,
        private readonly formBuilder: FormBuilder,
        private readonly communicareScheduleWebhookService: CommunicareScheduleWebhookService,
        private readonly dialog: MatDialog,
    ) {}

    tableColumns: string[] = ['indicationId', 'communicareScheduleId', 'status', 'event', 'errorReason', 'acoes'];
    dataSource = new MatTableDataSource<LogWebhookCommunicareDTO>();

    filterForm!: FormGroup;

    communicareWebhookEvent = Object.values(LogCommunicareWebhookEvent);

    communicareWebhookStatus = Object.values(LogCommunicareWebhookStatus);

    loading: boolean;

    total = 0;
    pageIndex = 0;
    pageSize = 10;

    filter: ListLogWebhookCommunicareFilterInputDTO;


    ngOnInit(): void {
        this.loading = true;
        this.createFormBuild();

        this.fetchCommunicareScheduleWebhook();
    }

    submit(): void {
        if (this.filterForm.invalid){
            return;
        };

        this.filter = this.filterForm.value;

        this.pageIndex = 0;

        this.fetchCommunicareScheduleWebhook(this.filter);
    }

    openModal(id: UUID): void {
        const findSelectedLog = this.dataSource.data.find(item => item.id === id);

        if(!findSelectedLog){
            this.snack.open(`O log selecionado não está disponível. Tente novamente mais tarde.`);
            return;
        }

        this.dialog.open(CommunicareScheduleWebhookModalComponent, {
            data: { payload: findSelectedLog.payload, },
            width: '850px'
        });
    }

    onSearch(event?: PageEvent): void {
        this.loading = true;

         if (event) {
            this.pageIndex = event.pageIndex;
            this.pageSize = event.pageSize;
        } else {
            this.pageIndex = 0;
        }

        this.fetchCommunicareScheduleWebhook(this.filter);
    }

    private fetchCommunicareScheduleWebhook(filter?: ListLogWebhookCommunicareFilterInputDTO): void {
        this.loading = true;
        this.dataSource.data = null;

        if (filter?.data && (filter?.data?.to == null || filter?.data?.from == null)) {
            filter.data = null;
        } 

        if(filter?.data && filter?.data?.to && filter?.data?.from){
            filter.data.from = new Date(filter.data.from).getTime();
            const toDate = new Date(filter.data.to);

            toDate.setHours(23, 59, 59, 900);

            filter.data.to = toDate.getTime();
        }

        this.communicareScheduleWebhookService.listAll(
            {
                data: filter?.data ?? null,
                status: filter?.status ?? null,
                event: filter?.event ?? null
            }, 
            this.pageIndex + 1, 
            this.pageSize)
            .pipe(
            tap( response => {
                this.dataSource.data = response.items;
                this.total = response.total;
            } ),
            finalize(() => this.loading = false),
        ).subscribe({
            error: (err) => {
                this.snack.open( err?.response?.message ?? `Não foi possível buscar logs do webhook. Tente novamente mais tarde.`);
            }
        });
    }

    private createFormBuild(): void {
        this.filterForm = this.formBuilder.group({
            status: [null],
            event: [null],
            data: this.formBuilder.group({
                from: [null],
                to: [null]
            },
            {
                validators: this.dateRangeValidator.bind(this)
            }
        )});
    }

    private dateRangeValidator( control: AbstractControl): ValidationErrors | null {
        const from = control.get('from')?.value;
        const to = control.get('to')?.value;

        if (!from && !to) {
        return null;
        }

        if (!from || !to) {
        return { dateRangeIncomplete: true };
        }

        return null;
    }
}